import { useState } from "react";

const FifthRowCard = ({
  organisation,
  role,
  duration,
  jobscope = [],
  showOrganisation = false,
}) => {
  const [open, setOpen] = useState(false);
  const hasJobScope = jobscope.length > 0;

  return (
    <div className="py-4 border-b border-gray-300 dark:border-gray-600">
      {showOrganisation && (
        <h3 className="text-base font-semibold text-lightText dark:text-darkText">
          {organisation}
        </h3>
      )}

      <button
        onClick={() => {
          if (window.innerWidth < 1024) {
            setOpen(!open);
          }
        }}
        className="w-full text-left flex justify-between items-start gap-4 cursor-default lg:cursor-text"
      >
        <div>
          <p className="text-sm font-medium text-gray-700 dark:text-gray-300">
            {role}
          </p>
          <p className="text-sm text-gray-500 dark:text-gray-400">{duration}</p>
        </div>

        {hasJobScope && (
          <span className="text-sm text-gray-500 lg:hidden">
            {open ? "−" : "+"}
          </span>
        )}
      </button>

      <ul
        className={`
          mt-3 list-disc space-y-1 pl-4 text-sm leading-relaxed
          text-gray-700 dark:text-gray-300
          ${hasJobScope ? "" : "hidden"}
          ${open ? "block" : "hidden"}
          lg:block
        `}
      >
        {jobscope.map((item, index) => (
          <li
            key={index}
            dangerouslySetInnerHTML={{ __html: item.description }}
          />
        ))}
      </ul>
    </div>
  );
};

export default FifthRowCard;
